import { render, staticRenderFns } from "./OfertaList.vue?vue&type=template&id=2ab07b5a&scoped=true&"
import script from "./OfertaList.vue?vue&type=script&lang=js&"
export * from "./OfertaList.vue?vue&type=script&lang=js&"
import style0 from "./OfertaList.vue?vue&type=style&index=0&id=2ab07b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab07b5a",
  null
  
)

export default component.exports